import { Validations } from '../../shared/forms';
import AutoCorrect from '../../shared/forms/AutoCorrect';
import { surname_prefix, sex } from '../../shared/CommonDefinitions';
import EmployeesDefinitions, { Options } from '../../employees/form/EmployeesDefinitions';
import Resources from "../../shared/forms/Resources";
import GenericFilter from "../../shared/tables/GenericFilter";

export default {
  firstname: {
    title: 'person.firstname.label',
    validation: Validations.name,
    autocorrect: AutoCorrect.firstUppercase,
    initial: ''
  },
  surname_prefix,
  surname: {
    title: 'person.surname.label',
    validation: Validations.name,
    autocorrect: AutoCorrect.firstUppercase,
    initial: ''
  },
  sex,
  birth_date: EmployeesDefinitions.birth_date,
  location: {
    title: 'Locatie',
    column: { filter: GenericFilter },
    value: (row) => row.location.name,
    validation: Validations.location.required(),
    initial: '',
    resource: Resources.applyLocation
  },
  mobile: {
    title: 'person.mobile.label',
    validation: Validations.phoneSimple.required(),
    autocorrect: AutoCorrect.noSpace,
    initial: ''
  },
  email: {
    title: 'person.email.label',
    initial: '',
    placeholder: 'person.email.placeholder',
    validation: Validations.email.required()
  },
  recruited_by_alternative: {
    title: 'person.recruited-by-alternative.label',
    initial: '',
    validation: Validations.recruitedByAlternative,
  },
  comment: {
    title: 'person.comment.label',
    initial: ''
  },
  public_transport_card: {
    title: 'person.public-transport-card.label',
    initial: '',
    options: {...Options.publicTransportCards}
  },
  number_of_workdays: {
    title: 'person.number-of-workdays.label',
    initial: '',
    options: {...Options.workdays}
  }
};
